<template>
    <div class="font-main font-normal" data-cy="container_app_main">
        <router-view :key="$route.path" />
        <!-- <router-view v-slot="{ Component  }">
            <template v-if="$route.name==='privilege' || $route.name==='campaign'">
                <KeepAlive>
                    <component :is="Component" />
                </KeepAlive>
            </template>
            <template v-else>
                <component :is="Component" />
            </template>
        </router-view> -->
        <ModalMaster data-cy="component_app_modal_master" :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";
import SearchStore from "@/store/SearchStore.js";
import ModalSetupMixin from '@/mixin/ModalSetupMixin.js';

export default {
    mixins: [ModalSetupMixin],
    created: function() {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
        AccountStore.methods.loginStatus({
            next: () => {
                // call function after check login status
            },
            error: () => {},
        });

    },
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
        SearchStore: SearchStore,
    },
}
</script>
<style lang="scss">
    @import "./style/base/base.scss";
    @import "./style/main.scss";
</style>
